import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";


const MyRating = ({ orderId, technicianPhone }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [feedback, setFeedback] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!rating) return alert("Please give a rating!");

    try {
      // 1. Fetch all records to find the one with matching orderId
     const res = await fetch(AIRTABLE_URL, {
  headers: AIRTABLE_HEADERS
});

      const data = await res.json();

      const matchingRecord = data.records.find(
        (record) => record.fields.orderId?.trim() === orderId
      );

      if (!matchingRecord) {
        alert("❌ Order not found.");
        return;
      }

      // 2. Update the matching record
     const patchRes = await fetch(`${AIRTABLE_URL}/${matchingRecord.id}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS,
  body: JSON.stringify({
    fields: {
      rating: rating.toString(),
      feedback: feedback
    }
  })
});

      if (patchRes.ok) {
        alert("✅ Rating submitted successfully!");
        navigate("/historybills");
      } else {
        alert("❌ Failed to submit rating.");
      }
    } catch (err) {
      console.error("Error submitting rating:", err);
      alert("Error occurred while submitting.");
    }
  };

  const handleClose = () => {
    navigate("/historybills");
  };

  const starStyle = {
    fontSize: "2rem",
    color: "#ccc",
    cursor: "pointer",
    marginRight: "5px",
  };

  const filledStarStyle = {
    ...starStyle,
    color: "#ffd700",
  };

  return (
    <div style={{ padding: 20, maxWidth: 400 }}>
      {/* X Button */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          right: 10,
          top: 10,
          background: "transparent",
          border: "none",
          fontSize: "25px",
          cursor: "pointer",
          color: "#555",
        }}
        title="Close"
      >
        X
      </button>

      <h3 style={{ marginTop: 40 }}>⭐ Rate Your Technician</h3>

      <div style={{ display: "flex", marginBottom: 10 }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            style={star <= (hover || rating) ? filledStarStyle : starStyle}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(null)}
          >
            ★
          </span>
        ))}
      </div>

      <textarea
        placeholder="Your feedback"
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        style={{
          width: "100%",
          padding: 10,
          minHeight: 80,
          marginTop: 10,
          resize: "none",
        }}
      />

      <button
        onClick={handleSubmit}
        style={{
          marginTop: 15,
          backgroundColor: "#28a745",
          color: "white",
          padding: "10px 15px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default MyRating;
